import { combineReducers } from "redux";

import adminreducer from "../src/components/AdminDashboard/reducer";
import dynamicFormreducer from "../src/components/DynamicForm/reducers";
import draftListReducer from "../src/components/DraftRegistration/reducers";
import submittedListReducer from "../src/components/SubmittedWarranties/reducers";
import globalReducer from "../src/globalStore/reducers";
import thankYouReducer from "../src/components/ThankYou/reducer";
import multipleWarrantiesThankYouReducer from "../src/components/MultipleWarrantiesThankYou/reducer";
import operationalReportReducer from "./components/OperationalReport/reducer";
import superAdminReducer from "./components/SuperAdmin/reducer";
import myCartReducer from "./components/MyCart/reducer";
const rootReducer = combineReducers({
    adminData: adminreducer,
    dynamicFormInfo: dynamicFormreducer,
    draftListInfo: draftListReducer,
    submittedListInfo: submittedListReducer,
    globalInfo: globalReducer,
    payments: thankYouReducer,
    thankYouInfo: multipleWarrantiesThankYouReducer,
    operationalReportInfo: operationalReportReducer,
    superAdminInfo: superAdminReducer,
    myCartInfo: myCartReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
